import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const PermissoesContext = createContext({});

export function PermissoesProvider({ children }) {
  const [permissoes, setPermissoes] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) carregarPermissoes();
    else setLoading(false);
  }, []);

  const carregarPermissoes = async () => {
    try {
      const r = await api.get('/permissoes/minhas/permissoes');
      setPermissoes(r.data);
    } catch(e) {
      console.error('Erro ao carregar permissoes:', e.message);
    } finally {
      setLoading(false);
    }
  };

  const temPermissao = (modulo, tipo = 'ver') => {
    if (!permissoes) return false;
    return permissoes[modulo]?.[tipo] === true;
  };

  return (
    <PermissoesContext.Provider value={{ permissoes, loading, temPermissao, carregarPermissoes }}>
      {children}
    </PermissoesContext.Provider>
  );
}

export const usePermissoes = () => useContext(PermissoesContext);
